<template>
  <div
    :class="taskWrapperClass"
    @mousedown="handleTaskMouseDown"
    @mousemove="handleTaskMouseMove"
    @mouseup="handleTaskMouseUp"
    @mouseleave="handleTaskMouseLeave"
  >
    <div class="task-row">
      <div class="task-title">{{ task.title }}</div>
      <TaskListActions v-if="task.creator.id === user.id" class="action" :task="task" />
    </div>
    <div v-if="task.creator" class="member-wrapper task-creator">
      <v-icon left>mdi-volume-medium</v-icon>
      <div class="member">
        <div :class="{ chip: true, isContributor: isCreator }">
          {{ contributorsByID[task.creator.id] | getName }}
        </div>
      </div>
    </div>
    <div v-if="task.receiver" class="member-wrapper task-receiver">
      <v-icon left>mdi-thumb-up</v-icon>
      <div class="member">
        <div :class="{ chip: true, isContributor: isReceiver }">
          {{ contributorsByID[task.receiver.id] | getName }}
        </div>
      </div>
    </div>
    <div class="time"><v-icon>mdi-calendar</v-icon> {{ taskTime }}</div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import mixins from '../helper/mixins'
import TaskListActions from './TaskListActions.vue'
import moment from 'moment'
import get from 'lodash-es/get'

export default {
  components: {
    TaskListActions
  },
  data() {
    return {
      mousePosition: {},
      isDragging: false
    }
  },
  props: {
    task: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('task', ['contributorsByID']),
    isContributor() {
      return this.isCreator || this.isReceiver
    },
    isCreator() {
      if (get(this.task, 'creator.id', '') === this.user.id) {
        return true
      } else {
        return false
      }
    },
    isReceiver() {
      if (get(this.task, 'receiver.id', '') === this.user.id) {
        return true
      } else {
        return false
      }
    },
    taskTime() {
      let startTime = '...'
      let endTime = '...'
      if (this.task.startTime) {
        startTime = moment(this.task.startTime).isValid() ? moment(this.task.startTime).format('DD/MM') : '...'
      }
      if (this.task.endTime) {
        endTime = moment(this.task.endTime).isValid() ? moment(this.task.endTime).format('DD/MM') : '...'
      }
      return `${startTime} - ${endTime}`
    },
    taskWrapperClass() {
      const classes = {
        'task-wrapper': true
      }
      if (this.task.category !== 'done' && this.task.endTime && moment(this.task.endTime).isValid()) {
        if (moment() >= moment(this.task.endTime).add(1, 'days')) {
          classes['over-deadline'] = true
        } else if (moment() >= moment(this.task.endTime)) {
          classes['close-to-deadline'] = true
        }
      }
      return classes
    }
  },
  methods: {
    handleTaskMouseDown(event) {
      this.mousePosition = {
        x: event.clientX,
        y: event.clientY
      }
      this.isDragging = true
    },
    handleTaskMouseMove() {
      // Drag detected
      if (this.isDragging && !this.isContributor && !this.$alert.alertData.show) {
        this.$alert.error('Bạn không thể di chuyển công việc này')
      }
    },
    handleTaskMouseLeave() {
      if (this.isDragging) {
        this.isDragging = false
      }
    },
    handleTaskMouseUp(event) {
      this.isDragging = false
      if (Math.abs(this.mousePosition.x - event.clientX) <= 5 && Math.abs(this.mousePosition.y - event.clientY) <= 5) {
        // Task click detected
        this.handleTaskClick()
      }
    },
    handleTaskClick() {
      this.$emit('click', this.task.id)
    }
  },
  mixins: [mixins]
}
</script>
<style lang="scss" scoped>
$tooltip-background-color: transparent;
.task-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
  padding: 12px;
  user-select: none;
}
.over-deadline {
  border: 1px solid red;
}
.close-to-deadline {
  border: 1px solid orange;
}
.task-wrapper:hover {
  cursor: pointer;
}
.task-wrapper:active {
  cursor: grabbing;
}
.task-row {
  display: flex;
}
.task-title {
  margin-right: auto;
}
.member-wrapper {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
}
.member {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
}

.time {
  display: flex;
  align-items: center;
  gap: 4px;
}
.chip {
  display: inline-block;
  padding: 4px 10px;
  background-color: #bbdefb;
  border-radius: 30px;
  white-space: nowrap;
}
.chip.isContributor {
  background-color: #fac533;
}
.action {
  margin-top: -12px;
  margin-right: -12px;
}
.v-menu__content {
  max-width: 80% !important;
}
</style>
